module.exports = __webpack_public_path__ + "static/media/react_native.50c28650.png";